import { render, staticRenderFns } from "./PersonalTaskList.vue?vue&type=template&id=1fc58d87&scoped=true"
import script from "./PersonalTaskList.vue?vue&type=script&lang=js"
export * from "./PersonalTaskList.vue?vue&type=script&lang=js"
import style0 from "./PersonalTaskList.vue?vue&type=style&index=0&id=1fc58d87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc58d87",
  null
  
)

export default component.exports